(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/defineProperty", "./index.less", "../swiper/swiper-item"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/defineProperty"), require("./index.less"), require("../swiper/swiper-item"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.defineProperty, global.index, global.swiperItem);
    global.unknown = mod.exports;
  }
})(typeof globalThis !== "undefined" ? globalThis : typeof self !== "undefined" ? self : this, function (_exports, _defineProperty2, _index, _swiperItem) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  _exports.default = void 0;
  _defineProperty2 = _interopRequireDefault(_defineProperty2);
  _swiperItem = _interopRequireDefault(_swiperItem);
  var _default2 = {
    render: function render() {
      var _vm = this;

      var _h = _vm.$createElement;

      var _c = _vm._self._c || _h;

      return _c('nx-swiper-item', {
        style: [_vm.itemStyle]
      }, [_vm._t("default")], 2);
    },
    name: 'nx-tab-pane-slide',
    components: (0, _defineProperty2.default)({}, _swiperItem.default.name, _swiperItem.default),
    inject: {
      rootTabsSlide: {
        from: 'rootTabsSlide',
        default: function _default() {
          /* istanbul ignore next */
          return this.$parent;
        }
      }
    },
    props: {
      label: {
        type: String
      },
      name: {
        type: String
      },
      disabled: {
        type: Boolean
      },
      itemHeight: {
        type: String
      }
    },
    computed: {},
    watch: {
      label: function label() {
        this.rootTabsSlide.$forceUpdate();
      },
      disabled: function disabled() {
        this.rootTabsSlide.$forceUpdate();
      }
    },
    data: function data() {
      return {
        itemStyle: {}
      };
    },
    created: function created() {
      this.rootTabsSlide.$_addPane(this);
      this.resetItemStyle({});
    },
    mounted: function mounted() {
      this.mode = this.rootTabsSlide.mode;
    },
    methods: {
      /**
       * 重置高度
       * @param titleBarHeight-tabsSlide组件的title-bar的高度
       */
      resetItemStyle: function resetItemStyle(_ref) {
        var _ref$titleBarHeight = _ref.titleBarHeight,
            titleBarHeight = _ref$titleBarHeight === void 0 ? 50 : _ref$titleBarHeight,
            _ref$isTabScroll = _ref.isTabScroll,
            isTabScroll = _ref$isTabScroll === void 0 ? true : _ref$isTabScroll;

        if (this.rootTabsSlide.mode === 'fullPage') {
          this.itemStyle = {
            height: this.itemHeight || "calc(100vh - ".concat(titleBarHeight, "px)"),
            overflowY: isTabScroll ? 'scroll' : 'hidden' // touchAction: isTabScroll ? 'auto' : 'pan-up',

          };
        }
      }
    },
    destroyed: function destroyed() {
      this.rootTabsSlide.$_removePane(this);
    }
  };
  _exports.default = _default2;
});